export default __webpack_public_path__ + "static/media/novu512.42a09db3.png";